import * as $ from 'jquery';

export class WatDatPho {
    protected onePageContainer: any = null;

    constructor() {
        $(() => this.initPage());
    }

    public initPage() {
        this.initNavigation();

        this.getOnePageContainer().onepage_scroll({
            loop: false
        });
    }

    protected getCurrentUrl(): string {
        return window.location.href;
    }

    public resizeSubpages(width: number, height: number) {
        let $subPage = $('.sub-page');
        $subPage.css('min-height', height + 'px');
        $subPage.width(width);
    }

    public initNavigation() {
        let $naviContainer = $('#navigation-container');

        $('.start', $naviContainer).click(_ => this.getOnePageContainer().moveTo(1));
        $('.about', $naviContainer).click(_ => this.getOnePageContainer().moveTo(2));
        $('.menu', $naviContainer).click(_ => this.getOnePageContainer().moveTo(3));
        $('.open-hours', $naviContainer).click(_ => this.getOnePageContainer().moveTo(4));
        $('.contact', $naviContainer).click(_ => this.getOnePageContainer().moveTo(5));
        $('.impressum').click(_ => this.getOnePageContainer().moveTo(6));
    }

    protected getOnePageContainer() {
        if (this.onePageContainer === null) {
            this.onePageContainer = $('#main');
        }
        return this.onePageContainer;
    }

    protected getSitenameFromPageIndex(index: number): string {
        switch (index) {
            case 1:
                return 'Startseite';
            case 2:
                return 'Über Uns';
            case 3:
                return 'Speisekarte';
            case 4:
                return 'Zeiten';
            case 5:
                return 'Kontakt';
            case 6:
                return 'Impressum';
            default:
                return 'unknown';
        }
    }
}


// WEBPACK FOOTER //
// ./src/WatDatPho.ts